import toDate from "../toDate/index.js";
import requiredArgs from "../_lib/requiredArgs/index.js";
export default function getMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var month = date.getMonth();
  return month;
}
